import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { PublicClientsFunnelValidationSchema } from "../schemas/create.schema";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosResponse } from "axios";
import { unFormatCnpj, unFormatCurrency } from "@/common/utils/unFormatters";

export type useCreatePublicCompanyLead = (
  onSuccess: () => void,
  onError: (error: any) => void
) => UseMutationResult<AxiosResponse<any, any>, unknown, PublicClientsFunnelValidationSchema>

const useCreatePublicCompanyLead: useCreatePublicCompanyLead = (onSuccess, onError) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['createPublicCompanyLead'],
    mutationFn: async (form: PublicClientsFunnelValidationSchema) => {
      const lead = {
        display_name: form.display_name,
        observations: form.observations,
        general_information_attributes: {
          cnpj: form.general_information?.cnpj ? unFormatCnpj(form.general_information?.cnpj) : undefined,
        },
        bidding_information_attributes: {
          notice_number: form.bidding_information.notice_number,
          contest_date: form.bidding_information.contest_date,
        },
        contract_attributes: {
          global_value: unFormatCurrency(form.contract.global_value),
          duration_in_months: form.contract.duration_in_months.value,
        }
      }

      return privateAxios.post('/funnel/public/leads', { 
        lead
      })
    },
    onSuccess: onSuccess,
    onError: onError
  });
}

export default useCreatePublicCompanyLead
